'use client';

import { useFormStatus } from 'react-dom';
import classNames from 'classnames';

import { Button } from '@/components/Buttons';
import { useEffect, useState } from 'react';

import { getFormToken } from '@/actions/antispam';

export const SubmitButton = ({ children }: { children: React.ReactNode }) => {
  const { pending } = useFormStatus();
  const [token, setToken] = useState<string>('');

  useEffect(() => {
    getFormToken().then(setToken);
  }, []);

  const disabled = pending || !token;

  return (
    <div className="flex flex-col items-end gap-4">
      <input type="hidden" name="form-token" value={token} />
      <Button
        className={classNames({ 'pointer-events-none touch-none': disabled })}
        type="submit"
        aria-disabled={disabled}
        disabled={disabled}
      >
        {children}
      </Button>
    </div>
  );
};
